import { useCallback, useEffect, useMemo, useState } from "react";
import AppLoader from "../../components/AppLoader";
import { ENDPOINT } from "../../services/api-endpoint";
import { getList } from "../../services/services";
import { usePageLoader } from "../../services/usePageLoader";
import "./mes-dashboard.scss";

const cardConfig = [
  {
    key: "parts",
    title: "Parts",
    subtitle: "Manage part definitions and specifications",
    icon: "fa-wrench",
    iconClass: "parts",
  },
  {
    key: "jobs",
    title: "Jobs",
    subtitle: "Schedule and track production jobs",
    icon: "fa-file-text-o",
    iconClass: "jobs",
  },
  {
    key: "workflows",
    title: "Workflows",
    subtitle: "Define production workflows and sequences",
    icon: "fa-random",
    iconClass: "workflows",
  },
  {
    key: "processes",
    title: "Processes",
    subtitle: "Manufacturing process definitions",
    icon: "fa-cogs",
    iconClass: "processes",
  },
  {
    key: "machines",
    title: "Machines",
    subtitle: "CNC machines and equipment",
    icon: "fa-microchip",
    iconClass: "machines",
  },
  {
    key: "recipes",
    title: "Recipes",
    subtitle: "Manufacturing recipes and parameter blueprints",
    icon: "fa-flask",
    iconClass: "recipes",
  },
  {
    key: "operators",
    title: "Operators",
    subtitle: "Operator management and skills",
    icon: "fa-users",
    iconClass: "operators",
  },
];

const MesDashboard = () => {
  const { isLoading, runWithLoading } = usePageLoader();
  const [summary, setSummary] = useState<any>({});
  const steps = [
    "Parts",
    "Jobs",
    "Workflows",
    "Processes",
    "Machines",
    "Recipes",
    "Operators",
  ];

  const onLoad = useCallback(async () => {
    try {
      await runWithLoading(async () => {
        const resp = await getList(ENDPOINT.DASHBOARD_SUMMARY);
        setSummary(resp || {});
      });
    } catch (e) {
      console.log(`Error loading dashboard summary: ${e}`);
    }
  }, [runWithLoading]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  const cardData = useMemo(
    () =>
      cardConfig.map((card) => ({
        ...card,
        total: Number(summary?.[card.key]?.total || 0),
        active: Number(summary?.[card.key]?.active || 0),
      })),
    [summary],
  );

  return (
    <div>
      {isLoading && <AppLoader text="Loading dashboard..." />}
      <div className="tv-dashboard-page tv-page-content">
          <div className="tv-flow-wrap">
            <h5>Production Flow</h5>
            <div className="tv-flow-steps">
              {steps.map((step, idx) => (
                <div key={step} className="tv-flow-step-item">
                  <div className={`tv-flow-step ${idx === 0 ? "active" : ""}`}>
                    <small>Step {idx + 1}</small>
                    <span>{step}</span>
                  </div>
                  {idx !== steps.length - 1 && (
                    <i className="fa fa-arrow-right tv-step-arrow" />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="row tv-dashboard-grid">
            {cardData.map((card) => (
              <div
                key={card.key}
                className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-3"
              >
                <div className="tv-dashboard-card">
                  <div className={`tv-card-icon ${card.iconClass}`}>
                    <i className={`fa ${card.icon}`} />
                  </div>
                  <h6>{card.title}</h6>
                  <p>{card.subtitle}</p>
                  <div className="tv-card-stats">
                    <div>
                      <strong>{card.total}</strong>
                      <span>Total</span>
                    </div>
                    <div>
                      <strong>{card.active}</strong>
                      <span>Active</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
      </div>
    </div>
  );
};

export default MesDashboard;

